module.exports = __webpack_public_path__ + "static/img/qick_img02.c2015607.png";